import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import {
  ActionWithPlayload,
  EntityAction,
  ErrorAction,
  isActionWithPayload,
} from '../../../store/types';

export interface AvailabilityState {
  [key: string]: {
    isFetching: boolean;
    error?: string;
  };
}

export const initialState: AvailabilityState = {};

type Action =
  | ActionWithPlayload<ActionType.FETCH_EXPERIMENT_AVAILABILITY_STARTED>
  | EntityAction<ActionType.FETCH_EXPERIMENT_AVAILABILITY_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_EXPERIMENT_AVAILABILITY_FAILED>;

export const availabilityReducer: Reducer<AvailabilityState, Action> = (
  state: AvailabilityState = initialState,
  action: Action,
) => {
  if (isActionWithPayload(action)) {
    const { domain, restrictBy } = action.payload;

    const key = `${domain}--${restrictBy}`;

    switch (action.type) {
      case ActionType.FETCH_EXPERIMENT_AVAILABILITY_STARTED:
        return {
          ...state,
          [key]: {
            isFetching: true,
            error: '',
          },
        };
      case ActionType.FETCH_EXPERIMENT_AVAILABILITY_SUCCEEDED:
        return {
          ...state,
          [key]: {
            isFetching: false,
          },
        };
      case ActionType.FETCH_EXPERIMENT_AVAILABILITY_FAILED:
        return {
          ...state,
          [key]: {
            isFetching: false,
            error: action.payload.message,
          },
        };
      default:
        return state;
    }
  }

  return state;
};

export default availabilityReducer;
